<template>
  <section>
    <h1>Подписание договора и оплата</h1>
    <p class="faq__clientText">
      Уважаемый клиент!
      <br><br>
      Перед подписанием договора страхования ознакомьтесь с проектом договора и приложениями к нему, проверьте
      достоверность указанных в нем сведений, подтвердите корректность данных.</p>
    <div class="faq__pdf">
      <a :href="project_link" target="_blank">Проект договора</a>
    </div>
    <div class="faq__checkbox">
      <input v-model="active" id="checkRules" type="checkbox" value="" />
      <label for="checkRules">Я соглашаюсь с условиями договора страхования и подтверждаю
        достоверность всех сведений, указанных в Проекте договора страхования, декларации Застрахованного
        (соответствующий раздел настоящего Договора). Все положения Проекта договора страхования, включая размер и
        порядок оплаты страховой премии, выплаты страховой и выкупной суммы, порядок расторжения и изменения Договора,
        и другие условия мне понятны. Я ознакомлен и согласен с
        <doc-preview-component
          :contract_id="contract_id"
          type="pdf"
          text="Правилами страхования."
          :link="rules"
          :index="2"
        />
      </label>
    </div>
    <span class="faq__text">
      Для подписания договора страхования введите смс-код, направленный Вам на указанный Вами номер телефона.
    </span>
    <sms-component
      :active="active"
      :view="'constructor'"
      :contract_id="contract_id"
      :other_params="{}"
      @signed="signed"
      style="margin-bottom: 20px;"
    />
    <span class="faq__text">
      После подписания и оплаты на указанный Вами адрес электронной почты будет направлено письмо с Вашим договором
      страхования, информация о договоре страхования появится в разделе «Мои договоры» в Вашем Личном кабинете.
    </span>
    <modal-component
      v-if="modal_data.active"
      :contract_id="contract_id"
      :title="modal_data.title"
      :body="modal_data.body"
      :active="modal_data.active"
      :type=type
      :params="modal_data.data"
    />
  </section>
</template>

<script>
import SmsComponent from "@/profile/components/SmsComponent.vue";
import ModalComponent from "@/profile/components/ModalComponent.vue";
import DocPreviewComponent from "@/profile/components/DocPreviewComponent.vue";

export default {
  name: "ConstructorComponent",
  props: ["contract_id", "rules", "project_link", "type"],
  data: () => {
    return {
      check_rules: false,
      active: false,
      isSigned: false,
      modal_data: {
        title: "",
        body: "",
        data: {},
        active: false
      }
    };
  },
  methods: {
    signed(result) {
      this.modal_data.title = "Договор страхования успешно подписан!";
      this.modal_data.data = result.result;
      this.modal_data.active = true;
    }
  },
  components: {
    SmsComponent,
    ModalComponent,
    DocPreviewComponent
  }
};
</script>

<style scoped>

</style>